module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-22.21049857.jpg";